function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-3.509 10.604)"
}, React.createElement("path", {
  d: "M69.094,29.391a55.879,55.879,0,0,1,13.1,1.718,42.608,42.608,0,0,1,13.1,5.584q6.013,3.866,6.013,8.805V56.881H73.819V45.5q0-9.45-9.02-15.893A32.472,32.472,0,0,1,69.094,29.391ZM19.483,31.109a55.879,55.879,0,0,1,13.1-1.718,55.879,55.879,0,0,1,13.1,1.718,41.3,41.3,0,0,1,12.993,5.584q5.906,3.866,5.906,8.805V56.881H.369V45.5q0-4.94,6.013-8.805A42.608,42.608,0,0,1,19.483,31.109ZM42.141,16.29a12.86,12.86,0,0,1-9.557,4.081,13.209,13.209,0,0,1-9.664-4.081,13.209,13.209,0,0,1-4.081-9.664,13.209,13.209,0,0,1,4.081-9.664,13.209,13.209,0,0,1,9.664-4.081,12.86,12.86,0,0,1,9.557,4.081,13.387,13.387,0,0,1,3.973,9.664A13.387,13.387,0,0,1,42.141,16.29Zm36.617,0a13.485,13.485,0,0,1-19.329,0,13.209,13.209,0,0,1-4.081-9.664A13.209,13.209,0,0,1,59.43-3.039a13.485,13.485,0,0,1,19.329,0,13.209,13.209,0,0,1,4.081,9.664A13.209,13.209,0,0,1,78.758,16.29Z",
  transform: "translate(54.468 35.32)",
  fill: "#bababa"
}), React.createElement("path", {
  d: "M35.569,88.339a1.4,1.4,0,0,1-1.3-.906L33.362,85h0a6.037,6.037,0,0,0-3.622-3.622l-2.434-.906a1.388,1.388,0,0,1,0-2.6l2.434-.906a6.037,6.037,0,0,0,3.622-3.622l.906-2.434a1.388,1.388,0,0,1,2.6,0l.906,2.434A6.037,6.037,0,0,0,41.4,76.962l2.434.906a1.343,1.343,0,0,1,.906,1.3,1.4,1.4,0,0,1-.906,1.3l-2.49.906A6.037,6.037,0,0,0,37.72,85l-.906,2.434A1.273,1.273,0,0,1,35.569,88.339Zm-5.151-9.169.113.057a8.337,8.337,0,0,1,4.981,4.981h0l.057.113.057-.113a8.337,8.337,0,0,1,4.981-4.981l.113-.057-.113-.057a8.337,8.337,0,0,1-4.981-4.981l-.057-.113-.057.113a8.337,8.337,0,0,1-4.981,4.981Zm12.622.849Zm-14.943,0Z",
  transform: "translate(-3.457 -24.379)",
  fill: "#b5b5b6",
  opacity: 0.8
}), React.createElement("path", {
  d: "M40.392,2.887h-1.7V1.132a1.132,1.132,0,1,0-2.264,0v1.7h-1.7a1.132,1.132,0,1,0,0,2.264h1.7v1.7a1.132,1.132,0,1,0,2.264,0v-1.7h1.7a1.135,1.135,0,0,0,1.132-1.132A1.055,1.055,0,0,0,40.392,2.887Z",
  transform: "translate(27.418 -3)",
  fill: "#b5b5b6",
  opacity: 0.6
}), React.createElement("path", {
  d: "M6.905,40.43h-1.7v-1.7a1.132,1.132,0,0,0-2.264,0v1.7H1.132a1.132,1.132,0,0,0,0,2.264h1.7v1.7a1.132,1.132,0,1,0,2.264,0v-1.7h1.7a1.135,1.135,0,0,0,1.132-1.132A.983.983,0,0,0,6.905,40.43Z",
  transform: "translate(11 -22.318)",
  fill: "#b5b5b6",
  opacity: 0.8
}), React.createElement("path", {
  d: "M12.992,156.03h-1.7v-1.7a1.132,1.132,0,1,0-2.264,0v1.7h-1.7a1.132,1.132,0,0,0,0,2.264h1.7v1.7a1.132,1.132,0,1,0,2.264,0v-1.7h1.7a1.135,1.135,0,0,0,1.132-1.132A1.069,1.069,0,0,0,12.992,156.03Z",
  transform: "translate(-2.691 -66.488)",
  fill: "#b5b5b6",
  opacity: 0.7
}), React.createElement("g", {
  transform: "translate(174.33 6.396)"
}, React.createElement("path", {
  d: "M334.807,27.714a1.4,1.4,0,0,1-1.3-.906l-.792-2.151a5.1,5.1,0,0,0-3.056-3.056l-2.151-.792a1.343,1.343,0,0,1-.906-1.3,1.4,1.4,0,0,1,.906-1.3l2.151-.792a5.1,5.1,0,0,0,3.056-3.056l.792-2.151a1.388,1.388,0,0,1,2.6,0l.792,2.151a5.1,5.1,0,0,0,3.056,3.056l2.151.792a1.343,1.343,0,0,1,.906,1.3,1.4,1.4,0,0,1-.906,1.3l-2.151.792a5.1,5.1,0,0,0-3.056,3.056l-.792,2.151A1.4,1.4,0,0,1,334.807,27.714Zm-.906-1.7Zm1.811,0Zm-4.981-6.509a7.364,7.364,0,0,1,4.019,4.019,7.364,7.364,0,0,1,4.019-4.019,7.364,7.364,0,0,1-4.019-4.019A7.19,7.19,0,0,1,330.732,19.507Zm10.528.906Zm-12.9,0Zm12.9-1.811Zm-12.962,0Z",
  transform: "translate(-353.072 -28.3)",
  fill: "#b5b5b6",
  opacity: 0.8
}), React.createElement("path", {
  d: "M315.075,67.143H313.32V65.389a1.189,1.189,0,1,0-2.377,0v1.755h-1.755a1.189,1.189,0,1,0,0,2.377h1.755v1.755a1.189,1.189,0,1,0,2.377,0V69.52h1.755a1.2,1.2,0,0,0,1.189-1.189A1.235,1.235,0,0,0,315.075,67.143Z",
  transform: "translate(-308 -34.258)",
  fill: "#b5b5b6",
  opacity: 0.7
}), React.createElement("path", {
  d: "M366.675,123.787H364.92v-1.7a1.189,1.189,0,0,0-2.377,0v1.755h-1.755a1.189,1.189,0,1,0,0,2.377h1.755v1.755a1.189,1.189,0,1,0,2.377,0V126.22h1.755a1.2,1.2,0,0,0,1.189-1.189A1.288,1.288,0,0,0,366.675,123.787Z",
  transform: "translate(-331.394 -71.866)",
  fill: "#b5b5b6",
  opacity: 0.8
}), React.createElement("path", {
  d: "M329.475,167.143H327.72v-1.755a1.2,1.2,0,0,0-1.189-1.189,1.161,1.161,0,0,0-1.189,1.189v1.755h-1.755a1.189,1.189,0,1,0,0,2.377h1.755v1.755a1.2,1.2,0,0,0,1.189,1.189,1.161,1.161,0,0,0,1.189-1.189V169.52h1.755a1.2,1.2,0,0,0,1.189-1.189A1.235,1.235,0,0,0,329.475,167.143Z",
  transform: "translate(-322.249 -79.657)",
  fill: "#b5b5b6",
  opacity: 0.6
})));

var SvgNoGroup = function SvgNoGroup(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 207.291,
    height: 109.807,
    viewBox: "0 0 207.291 109.807",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNoGroup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-group.fbbf82d1.svg";
export { ForwardRef as ReactComponent };